import styled from 'styled-components';
import {Radio, Space} from 'antd';
import DetailsTable from '../../TransactionsPage/DetailsTable';
import {bordersStyles} from '../../../../utils/styles';


const StyledInvoiceDetails = styled.div`
  form {

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-form-item-explain-error {
      text-align: right;
    }

    .ant-form-item-control-input,
    .ant-picker {
      width: 214px;
    }

    .invoice-vendor-select {
      .ant-form-item-control-input {
        max-width: 214px;
        width: max-content;
      }
    }

    .ant-form-item-label {
      display: none;
    }

    .ant-input {
      text-align: right;
    }

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-picker {
      &:not(:active):not(:focus):not(:hover) {
        border-color: transparent;
      }
    }

    .ant-select-outlined {
      &:not(:active):not(:focus):not(:hover) {
        .ant-select-selector {
          border-color: transparent;
        }
      }
    }

    .ant-picker {
      &.ant-picker-disabled {
        background: transparent;
        &:active,
        &:focus,
        &:hover {
          border-color: transparent;
        }
      }

      .ant-picker-input {
        input {
          margin-right: 8px;
          text-align: right;

          &[disabled] {
            color: rgba(0, 0, 0, 0.88);
          }
        }
      }
    }

    .ant-form-item-with-help {
      text-align: left;
    }

    .invoice-vendor-select {
      .ant-dropdown-trigger {
        border-color: transparent;
        font-size: 14px;
        justify-content: end;
        min-height: 32px;
        padding: 4px 12px;

        &:hover {
          border-color: ${props => props.theme.colors.primary_8};
        }
      }
    }
  }
`;

const StyledInvoiceDetailsRadioGroup = styled(Radio.Group)`
  label {
    &:last-of-type {
      margin-inline-end: 0;

      span.ant-radio+* {
        padding-inline-end: 0;
      }
    }
  }
`;

const StyledInvoiceDetailsVendorSpace = styled(Space)`
  justify-content: end;
`;

const StyledInvoiceDetailsTable = styled(DetailsTable)`
  tr {
    min-height: 34px;

    &:not(:last-of-type) {
      margin-bottom: 0;
    }
  }
`;

const StyledInvoiceDetailsTableSpace = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    ${bordersStyles.light};
    background-color: ${props => props.theme.colors.neutral_1};
    padding: 16px 24px;

    table {
      min-height: unset;
    }
  }
`;

export {
  StyledInvoiceDetails,
  StyledInvoiceDetailsRadioGroup,
  StyledInvoiceDetailsVendorSpace,
  StyledInvoiceDetailsTable,
  StyledInvoiceDetailsTableSpace
}
